import { humanFormat } from "@medoma/models/date-and-time";

export const formattedTime = (time: Date) => {
  return humanFormat(time, { timeStyle: "short" });
};

export const formattedTimeSpan = (from: Date, to: Date) => {
  return `${formattedTime(from)}-${formattedTime(to)}`;
};
